import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import AuthContext from '../../context/authContext';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

// Stripped-down user management for arena leads: edit employee master data
// (Stammdaten) of users in own assigned branches via the user:update:baseData right.
// The backend restricts both the list and the editable fields server-side.
function EmployeeBaseData() {
  const authCtx = useContext(AuthContext);

  if (!authCtx.checkRight('user:update:baseData')) {
    return <Navigate to='/welcome' replace />;
  }

  const userSchema = {
    firstName: {
      label: 'Vorname',
      api: {
        itemField: 'firstName',
      },
      placeholder: 'Vornamen eingeben',
      type: 'text',
      required: true,
      minWidth: '120px',
    },
    lastName: {
      label: 'Nachname',
      api: {
        itemField: 'lastName',
      },
      placeholder: 'Nachnamen eingeben',
      type: 'text',
      required: true,
      minWidth: '120px',
    },
    username: {
      label: 'Benutzername',
      api: {
        itemField: 'username',
      },
      type: 'text',
      required: false,
      readOnly: true,
      minWidth: '100px',
    },
    email: {
      label: 'Email',
      api: {
        itemField: 'email',
      },
      placeholder: 'Email eingeben',
      type: 'email',
      required: true,
      minWidth: '180px',
    },
    phone: {
      label: 'Telefon',
      api: {
        itemField: 'phone',
      },
      placeholder: 'Telefon eingeben',
      type: 'phone',
      required: false,
      minWidth: '120px',
    },
    birthDate: {
      label: 'Geburtsdatum',
      api: {
        itemField: 'birthDate',
      },
      placeholder: 'Geburtsdatum eingeben',
      type: 'date',
      required: false,
      minWidth: '120px',
    },
    employeeId: {
      label: 'Mitarbeiternummer',
      type: 'text',
      required: false,
      minWidth: '120px',
      readOnly: true,
    },
    personalData: {
      label: 'Personendaten',
      type: 'object',
      api: {
        itemField: 'personalData',
        skipSpecial: true,
      },
      schema: {
        streetAndNumber: {
          label: 'Straße und Hausnummer',
          type: 'text',
          required: false,
          placeholder: 'Musterstraße 123',
        },
        zip: {
          label: 'PLZ',
          type: 'text',
          required: false,
          placeholder: '12345',
        },
        city: {
          label: 'Ort',
          type: 'text',
          required: false,
          placeholder: 'Musterstadt',
        },
        gender: {
          label: 'Geschlecht',
          type: 'select',
          required: false,
          options: [
            { value: 'M', label: 'Männlich' },
            { value: 'W', label: 'Weiblich' },
            { value: 'D', label: 'Divers' },
            { value: '', label: 'keine Angabe' },
          ],
        },
        birthPlace: {
          label: 'Geburtsort',
          type: 'text',
          required: false,
          placeholder: 'Geburtsort eingeben',
        },
        nationality: {
          label: 'Nationalität',
          type: 'text',
          required: false,
          placeholder: 'Nationalität eingeben',
        },
      },
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
      <EditableList
        schema={userSchema}
        resourceType='user'
        searchPlaceholder='Mitarbeiter durchsuchen'
        parentIsEditable={true}
        options={{
          titleKey: 'username',
          disableCreate: true,
          disableDelete: true,
        }}
        visibleColumnKeys={[
          'firstName',
          'lastName',
          'username',
          'email',
          'phone',
          'birthDate',
          'employeeId',
        ]}
      />
    </Box>
  );
}

export default EmployeeBaseData;
